import React from "react"
import { MenuItem, Select } from "@material-ui/core"

import { AvailableValidationInputValue } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor"

export type CommunicationWindowState = "opened" | "closed"

export const COMMUNICATION_WINDOW_STATE_TO_LABEL: Record<CommunicationWindowState, string> = {
	opened: "Aberta",
	closed: "Fechada"
}

const CommunicationWindowInput: AvailableValidationInputValue = {
	title: "Janela de comunicação",
	defaultFirstParamValue: "{{communicationWindowState}}",
	secondParam: {
		render: ({ onChangeValidationValue, value }) => {
			const communicationWindowStates = Object.keys(COMMUNICATION_WINDOW_STATE_TO_LABEL) as CommunicationWindowState[]

			const selectedState = communicationWindowStates.find((state) => state === value)

			const handleChangeState = (state: CommunicationWindowState) => {
				onChangeValidationValue(state)
			}

			return (
				<Select
					variant="outlined"
					value={selectedState ?? ""}
					onChange={(event) => handleChangeState(event.target.value as CommunicationWindowState)}
					fullWidth
					displayEmpty
				>
					{communicationWindowStates.map((state) => (
						<MenuItem
							key={state}
							value={state}
						>
							{COMMUNICATION_WINDOW_STATE_TO_LABEL[state]}
						</MenuItem>
					))}
				</Select>
			)
		}
	},
	types: ["equals"],
	customValidationTypeName: {
		equals: "Está"
	}
}

export default CommunicationWindowInput
